import { render, staticRenderFns } from "./ExtendedTests.vue?vue&type=template&id=f9ee01a4&scoped=true"
import script from "./ExtendedTests.vue?vue&type=script&lang=js"
export * from "./ExtendedTests.vue?vue&type=script&lang=js"
import style0 from "./ExtendedTests.vue?vue&type=style&index=0&id=f9ee01a4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ee01a4",
  null
  
)

export default component.exports